import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { Briefcase, Coffee, Laptop, MapPin, Gift, TrendingUp } from "lucide-react";

const CareersPage = () => {
  const perks = [
    { icon: Coffee, title: "Esnek Çalışma", desc: "Haftada 2 gün ofis, 3 gün uzaktan çalışma modeli. Tamamen remote pozisyonlar da mevcut." },
    { icon: Gift, title: "Yan Haklar", desc: "Özel sağlık sigortası, yemek kartı, ulaşım desteği ve yıllık eğitim bütçesi." },
    { icon: TrendingUp, title: "Kariyer Gelişimi", desc: "Konferans katılımı, online eğitim platformları ve mentorluk programı." },
    { icon: Laptop, title: "Ekipman Desteği", desc: "Tercih ettiğiniz dizüstü bilgisayar, monitör ve ofis ekipmanları şirket tarafından sağlanır." },
  ];

  const positions = [
    { title: "Senior Backend Developer", dept: "Mühendislik", location: "İstanbul / Remote", type: "Tam Zamanlı" },
    { title: "ML Engineer - Voice AI", dept: "Yapay Zeka", location: "İstanbul / Remote", type: "Tam Zamanlı" },
    { title: "Frontend Developer (React)", dept: "Mühendislik", location: "İstanbul", type: "Tam Zamanlı" },
    { title: "DevOps Engineer", dept: "Altyapı", location: "Remote", type: "Tam Zamanlı" },
    { title: "Customer Success Manager", dept: "Satış", location: "İstanbul", type: "Tam Zamanlı" },
    { title: "Technical Writer", dept: "Dokümantasyon", location: "Remote", type: "Yarı Zamanlı" },
  ];

  const hero = (
    <PageHero
      eyebrow="Kariyer"
      title="Sesli AI'nın geleceğini birlikte inşa edelim"
      subtitle="Tutkulu, meraklı ve yenilikçi bir ekibin parçası olun. Verasist'te her gün yeni bir şey öğrenir, gerçek bir etki yaratırsınız."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/office-team.jpg" alt="Verasist ofis" height="360px" />
      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-6xl mx-auto">
            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Neden Verasist?</h2>
            <div className="mb-12 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
              <img
                src="/images/pages/business-meeting.jpg"
                alt="Verasist ekip toplantısı"
                className="w-full h-auto object-cover"
                style={{ maxHeight: "340px" }}
                loading="lazy"
              />
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
              {perks.map((p) => (
                <div
                  key={p.title}
                  className="p-6 rounded-2xl transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <p.icon size={20} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{p.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Açık Pozisyonlar</h2>
            <div className="space-y-3">
              {positions.map((pos) => (
                <div
                  key={pos.title}
                  className="p-5 rounded-2xl flex flex-col sm:flex-row sm:items-center justify-between gap-3 transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  <div>
                    <h3 className="text-[15px] font-semibold" style={{ color: "var(--fg)" }}>{pos.title}</h3>
                    <p className="text-[13px] mt-1" style={{ color: "var(--fg)", opacity: 0.7 }}>
                      {pos.dept} · {pos.location} · {pos.type}
                    </p>
                  </div>
                  <a
                    href="mailto:hr@verasist.ai"
                    className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-[13px] font-medium transition-all duration-200"
                    style={{ background: "var(--brand-cyan)", color: "#fff", whiteSpace: "nowrap" }}
                  >
                    <Briefcase size={14} /> Başvur
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-[28px] font-bold mb-4" style={{ color: "var(--fg)" }}>Açık pozisyon göremediniz mi?</h2>
            <p className="text-[15px] mb-2" style={{ color: "var(--fg)", opacity: 0.85 }}>
              Her zaman yetenekli insanlarla tanışmak isteriz. CV'nizi bize gönderin, uygun bir pozisyon açıldığında sizinle iletişime geçelim.
            </p>
            <p className="text-[14px] font-medium" style={{ color: "var(--brand-cyan)" }}>
              hr@verasist.ai
            </p>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default CareersPage;
